import styled from 'styled-components'
import { MEDIUMORANGE } from '../../../../styles/colors.style'
import { breakpoints } from '../../../../constants'

export const Box = styled.div`
	background: ${MEDIUMORANGE};

	img {
		display: block;
		margin: 0 auto;
		width: 100%;

		@media (min-width: ${breakpoints.MOBILE}px) {
			width: auto;
		}
	}
`
